export enum StorageKeys {
  BEARER_TOKEN = 'bearer-token',
  USER = 'logged-in-user',
  USER_DETAILS = 'logged-in-user-details',
  ROUTE = 'current-route',
  MARKER_TAG_VISIBILITY = 'marker-tag-visibility',
  TAG_VALUE_VISIBILITY = 'tag-value-visibility',
  HOST_APP = 'host-app',
  REMINDED_SUBSCRIPTION_SITES = 'remindedSubscriptionSites',
}